export async function askInsightQuestion(
    url,
    prompt,
    figure,
    question,
    previous_questions,
    prompt_instructions,
    onChunk,
    abortController
) {
    let chunks = '';
    try {
        const payload = {question, previous_questions, prompt_instructions};
        if (prompt) {
            payload.prompt = prompt;
        } else {
            payload.figure = JSON.stringify(figure);
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action: 'stream_question',
                payload: payload,
            }),
            signal: abortController.signal,
        });
        if (response.status !== 200) {
            const text = await response.text();
            throw new Error(text);
        }
        const decoder = new TextDecoder();
        const reader = response.body.getReader();
        let done = false;

        while (!done) {
            const chunk = await reader.read();
            done = chunk.done;
            const value = decoder.decode(chunk.value);
            if (value.startsWith('ERROR:')) {
                throw new Error(value.split('ERROR:').reverse()[0]);
            }
            chunks += decoder.decode(chunk.value);
            onChunk(chunks);
        }
        return chunks;
    } catch (error) {
        if (abortController.signal.aborted) {
            onChunk(`${chunks}\n\nInsights stopped generating...`)
            return chunks;
        }
        console.error(error);
        throw error;
    }
}
